import { ResolveFn } from '@angular/router';
import { Observable, tap, of, map } from 'rxjs';
import { inject } from '@angular/core';
import { OrganizationProvider, OrganizationProviderService } from 'riterz-core';

export const organizationProviderResolver: ResolveFn<Observable<OrganizationProvider|null>> = (
  route, 
  state,
  organizationProviderService: OrganizationProviderService = inject(OrganizationProviderService),
) => {
  const organizationProviderId = route.paramMap.get('organizationProviderId');
  const organizationId = route.parent?.parent?.paramMap.get('organizationId');


  if (!organizationId || !organizationProviderId) {
    return of(null);
  }

  // Check already loaded org providers
  const organizationProviders = route.parent?.parent?.data['organizationProviders'] as OrganizationProvider[];
  const organizationProvider = organizationProviders.find(op => op.id === organizationProviderId);

  if (organizationProvider) {
    return of(organizationProvider);
  }

  // If organization provider not loaded get them from server
  return organizationProviderService
    .getPublicOrganizationProvider(organizationId, organizationProviderId)
    .pipe(
      map(response => response.data),
      tap({
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        error: () => {}
      })
    );
    
};
